import { render, staticRenderFns } from "./select-search-block.vue?vue&type=template&id=457b304a&scoped=true&"
import script from "./select-search-block.vue?vue&type=script&lang=js&"
export * from "./select-search-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b304a",
  null
  
)

export default component.exports